import { KbaBasicInfo } from '../../model/kbaresponse';

export class KnowledgeBaseDetailInfo {
    kbaBasicInfo: KbaBasicInfo;
    itemType: string [];
    item: string [];
    summary: string;
    description: string;
    updatedDate: string;
    hasAttachment: boolean;
    voteCount: number;
    rating: number;
}
